import classNames from 'classnames';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { AccordionNew, AccordionNewProps } from './accordion-new.js';

export type AccordionData = { icon?: IconNameV1; text: string; title: string; key: string };

export function AccordionStyleFour<T extends { key: string }>({
  items,
  className,
  defaultToOpen,
  openIndexAsDefault,
  bodyContent,
  headerContent,
  restrictToOnlyOneChildOpen,
}: {
  items: T[];
  className?: string;
  bodyContent: (p: T) => JSX.Element;
  headerContent: (p: T) => JSX.Element;
} & Required<Pick<AccordionNewProps, 'defaultToOpen' | 'openIndexAsDefault' | 'restrictToOnlyOneChildOpen'>>) {
  if (items && items.length) {
    return (
      <>
        <AccordionNew
          dataComponent="accordian-style-four"
          className={classNames('Accordion--style-4', className)}
          headers={items.map((item) => {
            return (
              <div key={item.key} className="u-textSemibold">
                {headerContent(item)}
              </div>
            );
          })}
          defaultToOpen={defaultToOpen}
          openIndexAsDefault={openIndexAsDefault}
          restrictToOnlyOneChildOpen={restrictToOnlyOneChildOpen}
          bodies={items.map((item) => {
            return bodyContent(item);
          })}
        />
      </>
    );
  }
  return null;
}
